import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_up_orange",
  "use": "icon-icon_arrow_up_orange-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_up_orange\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"#F14B35\" fill-rule=\"nonzero\" d=\"M8 7.572 4.364 11 3 9.714 8 5l5 4.714L11.636 11z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol